import BlogSubscribeBtn from '@components/BlogSubscribeBtn';
import { Button } from '@components/Button/';
import { Dates } from '@components/Dates';
import EVImg from '@components/EVImg';
import { AspectBox } from '@components/Layout';
import Block from '@components/Layout/Block';
import RichText from '@components/RichText';
import SocialSharing from '@components/SocialMediaLinks/SocialSharing';
import { Document } from '@contentful/rich-text-types';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import {
  Author,
  CTAWrapper,
  CTAWrapperArticle,
  Date,
  Description,
  Eyebrow,
  Headline,
  ImageWrapper,
  MetaWrapper,
  ShareText,
  ShareWrapper,
  TextWrapper,
  Wrapper,
} from './style';

export interface PressReleaseArticleHeroProps {
  img?: string;
  eyebrow?: string;
  header: string;
  bodyText: string | Document;
  author?: string;
  publicationDate?: string;
  ctaUrl?: string;
  pageType?: string;
  reverse?: boolean;
  chimeId: string;
  chimeType: string;
  locale: string;
}

export const PressReleaseArticleHero: FC<PressReleaseArticleHeroProps> = ({
  img,
  eyebrow,
  header,
  bodyText,
  author,
  publicationDate,
  ctaUrl,
  pageType,
  reverse,
  chimeId,
  chimeType,
  locale,
}) => {
  const t = useTranslations();

  return (
    <Block narrow>
      <Wrapper $reverse={reverse}>
        {/*// reverse is a boolean, default is image is on the right on desktop, true means image is on the left on desktop */}
        {img && (
          <ImageWrapper>
            <AspectBox $ratio={1}>
              <EVImg src={img} sizes={['100vw', '100vw', '100vw', '600px']} priority />
            </AspectBox>
          </ImageWrapper>
        )}
        <TextWrapper>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          <Headline>{header}</Headline>

          {bodyText &&
            (typeof bodyText === 'string' ? (
              <Description>{bodyText as string}</Description>
            ) : (
              <RichText richText={bodyText as Document} />
            ))}

          {pageType === 'article' && (
            <MetaWrapper>
              {author && <Author>{author}</Author>}
              {publicationDate && (
                <Date>
                  <Dates startDate={publicationDate} locale={locale} />
                </Date>
              )}
            </MetaWrapper>
          )}

          {pageType === 'article' && (
            <CTAWrapperArticle>
              <BlogSubscribeBtn chimeId={chimeId} chimeType={chimeType} locale={locale} />

              {ctaUrl && (
                <ShareWrapper>
                  <ShareText>{t('SHARE')}</ShareText>
                  <SocialSharing
                    url={encodeURIComponent(ctaUrl)}
                    title={encodeURIComponent(header)}
                  />
                </ShareWrapper>
              )}
            </CTAWrapperArticle>
          )}

          {pageType === 'pressReleaseHomepage' && (
            <CTAWrapper>
              {ctaUrl && (
                <Button
                  url={ctaUrl}
                  variant="secondary"
                  label={t('Read Press Release')}
                  arrow={false}
                />
              )}
            </CTAWrapper>
          )}
        </TextWrapper>
      </Wrapper>
    </Block>
  );
};

export default PressReleaseArticleHero;
